import { ContactEmail, ContactPhone } from '@base/common/Contact';
import site from 'pro/config/site';
import styles from '@pro/help/default.module.less';

export default function ShippingTypes() {
    return (
        <div className={styles.help}>
            <h1>Shipping Types</h1>
            <p>We greatly value our customers and are committed to providing all items with fast, secure, and reliable delivery.</p>
            <p>Deliveries are typically made Monday through Friday. The shipping carrier may vary depending on the product size and the destination country.</p>
            <p>At present, we offer Standard Shipping only. Our delivery partners include:</p>
            <ul>
                <li>United States – USPS, UPS, or FedEx</li>
                <li>Canada – UPS, FedEx, or Canada Post</li>
                <li>Australia – Australia Post or TOLL</li>
                <li>Germany – DHL or DPD</li>
                <li>United Kingdom – DPD, Yodel, Hermes, or Royal Mail</li>
            </ul>

            <h2>Shipping Fees</h2>
            <p>{site.brand}&apos;s shipping charges are as follows:</p>
            <p>
                <strong>For the contiguous United States:</strong><br/>
                For orders under $99 USD, you will be charged based on the size and weight of the item. {site.brand} provides free shipping on purchases of $99 USD or more.
            </p>
            <p>
                <strong>For Canada:</strong><br/>
                For orders under CA$99, you will be charged based on the size and weight of the item. {site.brand} provides free shipping on purchases of CA$99 or more.
            </p>
            <p>
                <strong>For Australia:</strong><br/>
                For orders under $99 AUD, you will be charged based on the size and weight of the item. {site.brand} provides free shipping on purchases of $99 AUD or more.
            </p>
            <p>
                <strong>For Germany:</strong><br/>
                For orders under €99 EUR, you will be charged based on the size and weight of the item. {site.brand} provides free shipping on purchases of €99 EUR or more.
            </p>
            <p>
                <strong>For United Kingdom:</strong><br/>
                For orders under £99 GBP, you will be charged based on the size and weight of the item. Vivosun provides free shipping on purchases of £99 GBP or more.
            </p>

            <h2>Shipping Time</h2>
            <p>Shipping time for {site.brand} in the contiguous United States is typically 5-10 business days for Standard Shipping. Order processing time is not included but is normally 1 business day.</p>
            <p>Shipping time for {site.brand} in Canada is typically 5-10 business days for Standard Shipping. Order processing time is not included but is normally 1 business day.</p>
            <p><strong>*Notice: We cannot ship to P.O. boxes or military APOs.</strong></p>

            <h2>How To Track</h2>
            <p>Communication is key – we&apos;ll keep you updated by email throughout the shipping process. You will receive a confirmation email for shipments that contain tracking numbers. Also, your order&apos;s detail page will have a tracking link for you to track your package.</p>

            <h2>Contact Us</h2>
            <p>If you have more questions about tracking, please email us at <ContactEmail/> or call us on <ContactPhone/></p>
        </div>
    )
};